import React, { CSSProperties } from "react"
import MaterialTable from "material-table"
import { Box } from "@material-ui/core"
import { QuotedProduct } from "../../api/models/QuotedData"
import ProductPropertiesList from "../../ProductsSearch/components/ProductList/ProductPropertiesList"


interface IProps {
    items: QuotedProduct[],
    currency: string
}

const headerStyle : CSSProperties = {
    color: '#8A8A8A',
    fontSize: '0.6875rem',
    fontWeight: 400,
    textTransform: 'uppercase',
    lineHeight: '20px',
    letterSpacing: '0.92px'
}

export default function SupplierOrderProductsList({ items, currency }: IProps) {

    return (
        <MaterialTable
            components={{
                Container: Box,
            }}
            columns={
                [
                    {
                        title: 'Product',
                        field: 'name',
                        headerStyle
                    },
                    {
                        title: 'Properties',
                        field: 'properties',
                        headerStyle
                    },
                    {
                        title: 'Quantity',
                        field: 'quantity',
                        headerStyle
                    },
                    {
                        title: 'Price / Unit',
                        field: 'pricePerUnit',
                        headerStyle
                    },
                    {
                        title: 'Total',
                        field: 'price',
                        headerStyle
                    }
                ]
            }

            options={{
                paging: false,
                search: false,
                toolbar: false,
            }}

            data={items ? items.map((u) => Object.assign({}, u, { properties: (<ProductPropertiesList prodProperties={u.selectedProperties} />), pricePerUnit: `${u.pricePerUnit!} / ${u.unit.name}`, price: `${u.price!} ${currency}` })) : []}
            title={""}
        />
    )
}